import { StyleSheet } from 'react-native';
import type { WcColors } from './matchPickStats.helper';

export function getPickStatsSkeletonStyles(C: WcColors) {
  return StyleSheet.create({
    root: {
      flex: 1,
      backgroundColor: C.bg,
    },
    bone: {
      backgroundColor: C.panelHi,
    },
    backRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingTop: 12,
      paddingBottom: 8,
      gap: 6,
    },
    header: {
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingBottom: 16,
      paddingTop: 4,
      borderBottomWidth: 1,
      borderBottomColor: C.line,
      gap: 10,
    },
    teamsRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
      width: '100%',
      justifyContent: 'center',
    },
    scopeWrap: {
      marginTop: 18,
      marginHorizontal: 16,
    },
    scopeToggle: {
      flexDirection: 'row',
      backgroundColor: C.panelHi,
      borderRadius: 14,
      padding: 4,
      gap: 4,
      justifyContent: 'space-between',
      borderWidth: 1,
      borderColor: C.line,
    },
    scroll: {
      paddingBottom: 48,
    },
    sectionWrap: {
      marginTop: 18,
      marginHorizontal: 16,
    },
    panel: {
      borderRadius: 14,
      backgroundColor: C.panel,
      borderWidth: 1,
      borderColor: C.line,
      overflow: 'hidden',
    },
    mRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      paddingHorizontal: 10,
      paddingVertical: 10,
      borderBottomWidth: 1,
      borderBottomColor: C.line,
    },
    mRowLast: {
      borderBottomWidth: 0,
    },
    chips: {
      flex: 1,
      flexDirection: 'row',
      gap: 6,
    },
    piePanel: {
      padding: 14,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 16,
    },
    legend: {
      flex: 1,
      gap: 14,
    },
    legendRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    heatPanel: {
      padding: 12,
      gap: 5,
    },
    heatRow: {
      flexDirection: 'row',
      gap: 5,
    },
  });
}
